import { EGenerateQuizQuestionOptions, EQuizMode } from '@constants';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useQuizSectionsByCourse = (
  courseId?: string,
  mode?: EQuizMode,
  questionTypes?: EGenerateQuizQuestionOptions[]
) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['quizzes', 'sections-by-course', courseId, mode, questionTypes],
    queryFn: () => QuizService.getQuizSectionsByCourse(courseId!, mode!, questionTypes),
    enabled: !!courseId && !!mode
  });
  return {
    quizSections: data,
    isLoading,
    error
  };
};
